import React from 'react'
import Navbar from '../Navbar/Navbar'
import HeroSearch from '../Home/HeroSearch'
import RentalsGrid from '../Home/RentalsGrid'
import CategoriesGrid from '../Home/CategoriesGrid'
import WhyRentalCompany from '../Home/WhyRentalCompany'
import Testimonials from '../Home/Testimonials'
import FaqAccordion from '../Home/FaqAccordion'
import RentalStats from '../Home/RentalStats'
import Footer from '../Home/Footer'
import SpacesGrid from '../Home/SpacesGrid'

const Homepage = () => {
    return (
        <div>
        <Navbar/>
        <HeroSearch/>
        <RentalsGrid/>
   
     
        <WhyRentalCompany/>
        <Testimonials/>
        <FaqAccordion/>
        <RentalStats/>
        <Footer/>

        </div>
    )
}

export default Homepage